if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (window.isMobile()) this.slider();
        this.clickEvent();
      }

      clickEvent = () => {
        let thumbsSlides = document.querySelectorAll('.thumbsSlider .change-main-image', this);
        thumbsSlides.length > 0 && thumbsSlides.forEach(el => {
          el.addEventListener('click', (event) => {
            this.setActiveSlide(el.getAttribute('data-slide-id'));
          })
        })

        if (!window.isMobile()) {
          let mainSliderWrapper = document.querySelector('.main-slider-wrapper', this);
          mainSliderWrapper?.addEventListener('mousemove', function (e) {
            let r = mainSliderWrapper.querySelector('.swiper-slide.active img');
            const l = r?.clientHeight || 0;
            const o = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) - 142;
            const a = l - o;
          
            let bb = e.clientY * (a / o);
            document.querySelector('.swiper-slide.active img', mainSliderWrapper).style.transform = `translate3d(0px, -${bb}px, 0px) scale(1)`;
          });
        }
      } 

      slider = () => {
        setTimeout(() => {
          this.mainSlider = new Swiper(this.querySelector('.main-slider-wrapper'), {
            zoom: false,
            slidesPerView: 1,
            loop: false,
            allowTouchMove: false,
          });
          this.mainSlider.on('slideChange', (e) => {
            let el = document.querySelector(`.thumbsSlider [data-slide="${this.mainSlider.realIndex}"]`);
            this.setActiveSlide(el.getAttribute('data-slide-id'), false);
          });
        }, 500);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      setActiveSlide(mediaId, slide = true) {
        if (!mediaId) {
          mediaId = this.openedBy.getAttribute('data-media-id');
        }
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.closest('.swiper-slide')?.classList.remove('active');
        });
        this.querySelectorAll(
          `.thumbsSlider [data-slide-id]:not([data-slide-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const thumbActiveMedia = this.querySelector(`.thumbsSlider [data-slide-id="${mediaId}"]`);
        activeMedia.closest('.swiper-slide')?.classList.add('active');
        thumbActiveMedia.classList.add('active');
        if (window.isMobile() && this.mainSlider && slide) this.mainSlider.slideTo(parseInt(thumbActiveMedia.dataset.slide));
      }

      showActiveMedia() {
        this.setActiveSlide();
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
